// extracted by mini-css-extract-plugin
export default {"base":"Input_base__nk8Xw","error":"Input_error__1wKFK"};